import React from 'react'
import { useSelector } from 'react-redux'
import { Layout, Typography, Modal, Menu, Avatar, Dropdown } from 'antd'
import {
  HomeOutlined,
  MailOutlined,
  CalendarOutlined,
  DatabaseOutlined,
  DollarCircleOutlined,
  ExclamationCircleOutlined,
  UserOutlined
} from '@ant-design/icons'
import { useLocation, useHistory } from 'react-router-dom'
import { BarLoader } from 'react-spinners'

import { useAuth } from '../authContext'
import { useFirebase } from '../firebaseContext'
import { HamburgerButton } from '../components'

const { Header, Content, Footer, Sider } = Layout
const { confirm } = Modal
const { Title } = Typography

export default function PrivateLayout({ children }) {
  const { loading } = useSelector(state => state)
  const [user, setUser] = React.useState({})
  const [collapsed, setCollapsed] = React.useState(true)
  const { pathname } = useLocation()
  const history = useHistory()
  const firebase = useFirebase()
  const auth = useAuth()

  React.useEffect(() => {
    getUser()
  }, [])

  const getUser = async () => {
    const u = await firebase.getUser()
    setUser(u)
  }

  const showConfirm = () => {
    confirm({
      title: 'Sesión',
      icon: <ExclamationCircleOutlined />,
      content: '¿Estás seguro de cerrar sesión?',
      okText: 'Aceptar',
      cancelText: 'Cancelar',
      onOk() {
        auth.signout(() => {
          history.replace({ pathname: '/login' })
        })
      },
      onCancel() {
        console.log('Canceled')
      },
    })
  }

  const handleNav = to => {
    history.push({ pathname: to })
  }

  const route = pathname.split('/')[1]

  const menu = (
    <Menu>
      <Menu.Item onClick={showConfirm}>
        Cerrar Sesión
      </Menu.Item>
    </Menu>
  )

  return (
    <React.Fragment>
      {/* <OverlaySpinner /> */}
      <Layout style={{ minHeight: '100vh' }}>
        <Sider width={300} collapsible collapsed={collapsed} trigger={null}>
          <HamburgerButton toggle={!collapsed} setToggle={() => setCollapsed(!collapsed)} />
          <div className="logo">
            <img src={process.env.PUBLIC_URL + '/logow.svg'} />
          </div>
          <Menu theme="dark" defaultSelectedKeys={[route || 'home']} mode="inline">
            <Menu.Item key="home" icon={<HomeOutlined />} onClick={() => handleNav('/')}>
              Inicio
            </Menu.Item>
            <Menu.Item key="citas" icon={<CalendarOutlined />} onClick={() => handleNav('/citas')}>
              Citas
            </Menu.Item>
            <Menu.Item key="users" icon={<UserOutlined />} onClick={() => handleNav('/users')}>
              Usuarios
            </Menu.Item>
            <Menu.Item key="mensajes" icon={<MailOutlined />} onClick={() => handleNav('/mensajes')}>
              Mensajes
            </Menu.Item>
            <Menu.Item key="posts" icon={<DatabaseOutlined />} onClick={() => handleNav('/posts')}>
              Publicaciones
            </Menu.Item>
            <Menu.Item key="promociones" icon={<DollarCircleOutlined />} onClick={() => handleNav('/promociones')}>
              Promociones
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ paddingRight: 10 }}>
            <div className="head-content">
              <Title level={4}>Consultorio de Urología</Title>
              <div className="user-menu">
                <span>{user.email}</span>
                <Dropdown overlay={menu} placement="bottomLeft" arrow>
                  <Avatar size="large" icon={<UserOutlined />} />
                </Dropdown>
              </div>
            </div>
          </Header>
          {loading ? <BarLoader width="100%" height={4} color="#11698e" /> : <div style={{height: 4}}></div>}
          <Content style={{ margin: '0 16px' }}>
            <div className="site-layout-background" style={{ padding: 24, marginTop: 24, minHeight: 360 }}>
              { children }
            </div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>Dr. Gabriel Iván Farrera Santillán ©2021 Urología Integral Avanzada</Footer>
        </Layout>
      </Layout>
    </React.Fragment>
  )
}